import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	titleInviteUser: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.title.invite-user',
		defaultMessage:
			'{userCount, plural, one {{singleUserTitle} needs} other {Teammates need}} access to {productName}',
		description:
			'Flag title shown when some linked users are missing access to the resource. userCount is the number of users missing access; singleUserTitle is the first name of the single user who needs access (only used in the singular case); productName is the destination product such as "Jira" or "Confluence".',
	},
	descriptionInviteUser: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.description.invite-user',
		defaultMessage: `{userCount, plural,
				one { {source, select,
					slack  {We noticed {singleUserTitle} is in your Slack thread but doesn''t have access to {spaceName}. Invite them to join you.}
					mailto {{singleUserTitle} doesn''t have access to {spaceName}. Invite them to join you.}
					other  {Invite them to join you.}
					} }
				other { Invite teammates from your {source, select, slack {Slack channel} mailto {emails} other {link}} who may need access to collaborate with you in {spaceName}. }
			}`,
		description:
			'Flag description shown when users in the Slack thread are missing access to the resource.',
	},
	descriptionInviteNonUser: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.description.invite-non-user',
		defaultMessage:
			'{email} needs access to {productName}. Invite them to start collaborating in {spaceName}.',
		description:
			'Flag description shown when someone without an account is missing access to the resource.',
	},
	ctaInvite: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.cta.invite',
		defaultMessage: '{userCount, plural, one {Invite} other {Add {userCount} people}}',
		description:
			'Label for the invite CTA button on the invite on 3p link flag. userCount is the number of users to invite.',
	},
	ctaNotNow: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.cta.not-now',
		defaultMessage: 'Not now',
		description:
			'Label for the dismiss action on the invite on 3p link flag. Closes the flag without taking action.',
	},
	avatarGroupLabel: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.avatar-group.label',
		defaultMessage: 'Teammates without access',
		description:
			'Accessible label for the avatar group of teammates who do not yet have access to the resource.',
	},
	fallbackSingleUserTitle: {
		id: 'invite-on-third-party-link.invite-on-third-party-link-flag.fallback-single-user-title',
		defaultMessage: 'Someone',
		description: 'Fallback title used when the user does not have an account.',
	},
});
